import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ApiService } from "../../services/api.service";
import { catchError, map, switchMap, throwError } from "rxjs";
import { Store } from "@ngrx/store";
import { ADD_MESSAGE } from "../messages/messages.actions";
import { HttpErrorResponse } from "@angular/common/http";
import { APPROVVIGIONAMENTO_ORDINE, APPROVVIGIONAMENTO_ORDINE_FINALE, APPROVVIGIONAMENTO_ORDINE_FINALE_SUCCESS, APPROVVIGIONAMENTO_ORDINE_SUCCESS, APPROVVIGIONAMENTO_PRODOTTI, APPROVVIGIONAMENTO_PRODOTTI_SUCCESS, CATALOGO_APPARTENENZA, CATALOGO_APPARTENENZA_RESO, CATALOGO_APPARTENENZA_RESO_SUCCESS, CATALOGO_APPARTENENZA_SUCCESS, CREA_RESO, CREA_RESO_SUCCESS, ESPORTA_STORICO_ORDINI, ESPORTA_STORICO_ORDINI_SUCCESS, GENERTE_BARCODE_SCATOLA_RESO, GENERTE_BARCODE_SCATOLA_RESO_SUCCESS, MAIL_STORICO_ORDINI, MAIL_STORICO_ORDINI_SUCCESS, PRODOTTI_RESO, PRODOTTI_RESO_SUCCESS, RETRIEVE_PRODUCTS_BOX_ACCEPTANCE, RETRIEVE_PRODUCTS_BOX_ACCEPTANCE_SUCCESS, STORICO_ORDINI_MATERIALI, STORICO_ORDINI_MATERIALI_SUCCESS } from "./consumable-warehouse.actions";
import { ICatalogoAppartenenzaResoResponse, ICatalogoAppartenenzaResponse, IProdottiResoResponse, IProductsBoxAcceptance } from "../../interfaces/catalogo-appartenenza";
import { IResponseApprovvigionamentoOrdine, IResponseApprovvigionamentoOrdineFinale, IResponseApprovvigionamentoProdotti } from "../../interfaces/approvvigionamento-ordine";
import { IResponseGenerateBarcodeReso } from "../../interfaces/generate-barcode-scatola-reso";
import { IResponseCreaReso } from "../../interfaces/crea-reso";
import { IResponseStoricoOrdiniMateriali } from "../../interfaces/storico-ordini-materiali";

@Injectable()
export class ConsumableWarehouseEffects {

  retrieveCatalogoAppartenenza$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CATALOGO_APPARTENENZA),
      switchMap(() => this.api.retrieveCatalogoAppartenenza()),
      map((responseCatalogoAppartenenza: ICatalogoAppartenenzaResponse) => {
        return CATALOGO_APPARTENENZA_SUCCESS({ responseCatalogoAppartenenza });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveApprovvigionamentoOrdine$ = createEffect(() =>
    this.actions$.pipe(
      ofType(APPROVVIGIONAMENTO_ORDINE),
      switchMap(({payload}) => this.api.retrieveApprovvigionamentoOrdine(payload)),
      map((responseApprovvigionamentoOrdine: IResponseApprovvigionamentoOrdine) => {
        return APPROVVIGIONAMENTO_ORDINE_SUCCESS({ responseApprovvigionamentoOrdine });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveApprovvigionamentoProdotti$ = createEffect(() =>
    this.actions$.pipe(
      ofType(APPROVVIGIONAMENTO_PRODOTTI),
      switchMap(({payload}) => this.api.retrieveApprovvigionamentoProdotti(payload)),
      map((responseApprovvigionamentoProdotti: IResponseApprovvigionamentoProdotti) => {
        return APPROVVIGIONAMENTO_PRODOTTI_SUCCESS({ responseApprovvigionamentoProdotti });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveApprovvigionamentoOrdineFinale$ = createEffect(() =>
    this.actions$.pipe(
      ofType(APPROVVIGIONAMENTO_ORDINE_FINALE),
      switchMap(({payload}) => this.api.retrieveApprovvigionamentoOrdineFinale(payload)),
      map((responseApprovvigionamentoOrdineFinale: IResponseApprovvigionamentoOrdineFinale) => {
        return APPROVVIGIONAMENTO_ORDINE_FINALE_SUCCESS({ responseApprovvigionamentoOrdineFinale });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveCatalogoAppartenenzaReso$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CATALOGO_APPARTENENZA_RESO),
      switchMap(() => this.api.retrieveCatalogoAppartenenzaReso()),
      map((responseCatalogoAppartenenzaReso: ICatalogoAppartenenzaResoResponse) => {
        return CATALOGO_APPARTENENZA_RESO_SUCCESS({ responseCatalogoAppartenenzaReso });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveProdottiReso$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PRODOTTI_RESO),
      switchMap(({returnType}) => this.api.retrieveProdottiReso(returnType)),
      map((responseProdottiReso: IProdottiResoResponse) => {
        return PRODOTTI_RESO_SUCCESS({ responseProdottiReso });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveGenerateBarcodeReso$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GENERTE_BARCODE_SCATOLA_RESO),
      switchMap(({payload}) => this.api.retrieveGenerateBarcodeReso(payload)),
      map((responseGenerateBarcodeScatolaReso: IResponseGenerateBarcodeReso) => {
        return GENERTE_BARCODE_SCATOLA_RESO_SUCCESS({ responseGenerateBarcodeScatolaReso });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveCreaReso$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CREA_RESO),
      switchMap(({payload}) => this.api.retrieveCreaReso(payload)),
      map((responseCreaReso: IResponseCreaReso) => {
        return CREA_RESO_SUCCESS({ responseCreaReso });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveStoricoOrdiniMateriali$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STORICO_ORDINI_MATERIALI),
      switchMap(({payload}) => this.api.retrieveStoricoOrdiniMateriali(payload)),
      map((responseStoricoOrdiniMateriali: IResponseStoricoOrdiniMateriali) => {
        return STORICO_ORDINI_MATERIALI_SUCCESS({ responseStoricoOrdiniMateriali });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveEsportaStoricoOrdini$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ESPORTA_STORICO_ORDINI),
      switchMap(({payload}) => this.api.retrieveEsportaStoricoOrdini(payload)),
      map((responseEsportaStoricoOrdini: any) => {
        return ESPORTA_STORICO_ORDINI_SUCCESS({ responseEsportaStoricoOrdini });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveMailStoricoOrdini$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MAIL_STORICO_ORDINI),
      switchMap(({payload}) => this.api.retrieveMailStoricoOrdiniMateriali(payload)),
      map((responseMailStoricoOrdini: IResponseStoricoOrdiniMateriali) => {
        return MAIL_STORICO_ORDINI_SUCCESS({ responseMailStoricoOrdini });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveProductsBoxAcceptance$ = createEffect(() =>
  this.actions$.pipe(
    ofType(RETRIEVE_PRODUCTS_BOX_ACCEPTANCE),
    switchMap(() => this.api.retrieveProductsBoxAcceptance()),
    map((responseProductsBoxAcceptance: IProductsBoxAcceptance) => {
      return RETRIEVE_PRODUCTS_BOX_ACCEPTANCE_SUCCESS({ responseProductsBoxAcceptance });
    }),
    catchError((error: HttpErrorResponse) => {
      this.addErrorMessage(error.message)
      return throwError({ error });
    })
  )
);

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private router: Router,
    private store: Store
  ) {}


  private addErrorMessage(message: string): void {
    this.store.dispatch(ADD_MESSAGE({ message: message }));
  }
}
